import ProductListPageTypeConfig from "../ProductListPageTypeConfig";
import elementService from "../../../../js/common/ElementService";

export class ProductListSearchEvent extends Event {
    public static readonly Type = "search";

    constructor(public readonly query: string) {
        super(ProductListSearchEvent.Type);
    }
}

export default new class ProductListSearchFormService extends EventTarget {
    private categorySearchInput: HTMLInputElement | null | undefined = undefined;

    public init(pageTypeConfig: ProductListPageTypeConfig): void {
        this.initSearchForm(pageTypeConfig);
        this.initMostSearchedLinks();
    }

    public setSearchQuery(searchQuery: string): void {
        const categorySearchInput = this.getCategorySearchInput();

        if (categorySearchInput !== null) {
            categorySearchInput.value = searchQuery;
        }
    }

    public clearSearchQuery(): void {
        this.setSearchQuery("");
    }

    private initSearchForm(pageTypeConfig: ProductListPageTypeConfig): void {
        if (pageTypeConfig.listType === "category" || pageTypeConfig.showSubSearchFilter) {
            this.initCategorySearchForm();
        }
    }

    private initCategorySearchForm(): void {
        const categorySearchButton = document.querySelector<HTMLButtonElement>(".js-filter-category-search-button");
        const categorySearchClearButton = document.querySelector<HTMLButtonElement>(".js-filter-category-search-clear");
        const categorySearchInput = this.getCategorySearchInput();

        if (categorySearchButton === null || categorySearchInput === null || categorySearchClearButton === null) {
            return;
        }

        categorySearchInput.addEventListener("keyup", (event: KeyboardEvent) => {
            if (event.key === "Enter") {
                this.searchByQuery(categorySearchInput.value);
            }
        });

        categorySearchButton.addEventListener("click", () => this.searchByQuery(categorySearchInput.value));
        categorySearchClearButton.addEventListener("click", () => this.clearSearchQuery());
    }

    private initMostSearchedLinks(): void {
        for (const searchLink of document.querySelectorAll<HTMLAnchorElement>(".js-category-search-link")) {
            searchLink.addEventListener("click", (event: MouseEvent) => {
                event.preventDefault();
                this.applyQuery(searchLink);
            });
        }
    }

    private applyQuery(searchLink: HTMLAnchorElement): void {
        const query = elementService.elementData(searchLink, "query");

        const categorySearchInput = this.getCategorySearchInput();

        if (categorySearchInput !== null) {
            categorySearchInput.value = query;
        }

        this.searchByQuery(query);
    }

    private searchByQuery(query: string): void {
        this.dispatchEvent(new ProductListSearchEvent(query.trim()));
    }

    private getCategorySearchInput(): HTMLInputElement | null {
        if (this.categorySearchInput === undefined) {
            this.categorySearchInput = document.querySelector<HTMLInputElement>(".js-filter-category-search-input");
        }

        return this.categorySearchInput;
    }
}();
